import { useContext, useMemo } from 'react';

import { Role, useRoles } from '../../features/auth/hooks';
import type { IContext } from './Context';
import Context from './Context';

export { default as Provider } from './Provider';

export function useMenu(): IContext {
  const context = useContext(Context);
  const { hasRole } = useRoles();

  // Menu requires to have certain roles.
  const hasRequiredRole = hasRole(
    Role.SystemAdministrator | Role.GlobalAdministrator | Role.DomainAdministrator | Role.UserAdministrator | Role.User,
  );

  return useMemo(() => {
    const { menus, ...other } = context;

    return {
      menus: hasRequiredRole ? menus : [],
      ...other,
    };
  }, [context, hasRequiredRole]);
}
